<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-dedication element-with-heading" epub:type="dedication" id="dedication" role="doc-dedication">
<div class="heading heading-with-title heading-without-image" id="dedication-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Dedication</h1>
</div>
</div>
</div>
</div>
<div class="text" id="dedication-text">
<p class="first first-in-chapter first-full-width dedication-content"><i>The following stories are more than just some of my favorite of my works: they’re important to me because of who I wrote them for. Each story in this book was inspired by or written in memory of someone who made a difference in my life. These are my tributes to those people; and so I am honored to share these stories with you.</i></p>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right dedication-content">—Martin L. Shoemaker</p>
</div>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?8ecac442